// 简单在 with 体系上，完成像 store、i18n 这样的特殊生命周期对象的创建
export function createExtraInstanceHelper(withFunc, appendCtx) {
  // 不严格区分具体时序，按尽可能重用实例的逻辑
  return {
    async handleOnGetInitialProps(appCtx, createFunc) {
      let extraInstance
      if (process.server) {
        extraInstance = await createFunc()
      } else {
        extraInstance = window[withFunc]
        if (!extraInstance) {
          extraInstance = await createFunc()
          window[withFunc] = extraInstance
        }
      }
      appendCtx(appCtx.ctx, extraInstance)
      if (process.server) {
        // 将此对象合并进 initialProps
        return {
          // 通过在 getInitialProps 返回一个值为 value 的项
          // ssr 时，可正常传递
          // ssr => client 时，将丢失
          [withFunc]: () => extraInstance,
        }
      } else {
        return {}
      }
    },
    handleOnConstructor(props, createFunc) {
      let extraInstance
      if (props[withFunc]) {
        extraInstance = props[withFunc]()
      } else if (process.browser) {
        extraInstance = window[withFunc]
        if (!extraInstance) {
          extraInstance = createFunc()
          window[withFunc] = extraInstance
          if (extraInstance && typeof extraInstance.then === 'function') {
            if (props.ctx.lifecycleStatus.isExportMode) {
              throw new Error('错误。export 时，不能返回 promise（异步）')
            } else {
              throw new Error(
                '错误。constructor 时序上，不允许返回 promise（异步）'
              )
            }
          }
        }
      } else {
        throw new Error('框架时序异常')
      }
      appendCtx(props.ctx, extraInstance)
    },
    // 额外多在 render 上调用一次 appendCtx
    // 确保即使发生了额外的多次 render，ctx 附加状态也正确
    handleAppendOnRender(props) {
      let extraInstance
      if (props[withFunc]) {
        extraInstance = props[withFunc]()
      } else if (process.browser) {
        extraInstance = window[withFunc]
      } else {
        throw new Error('框架时序异常')
      }
      appendCtx(props.ctx, extraInstance)
    },
  }
}
